import axios from 'axios';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { initialize } from 'redux-form';

const API = `${consts.API_URL}/usuario`;

export const USUARIO_MODO_TELA = 'USUARIO_MODO_TELA';
export const USUARIO_SET_AGUARDANDO = 'USUARIO_SET_AGUARDANDO';
export const USUARIO_LISTADO = 'USUARIO_LISTADO';

export function setModoTela(modo, registro = {}) {
    return {
        type: USUARIO_MODO_TELA,
        payload: {
            modo,
            registro
        }
    };
}

export function setAguardando(aguardando) {
    return {
        type: USUARIO_SET_AGUARDANDO,
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('usuarioForm', registro)
    ];
}

export function getLista() {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const resp = await axios.get(API, {
                params: {
                    usuario: true
                }
            });

            dispatch({
                type: USUARIO_LISTADO,
                payload: resp
            });

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function salvar(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const request = registro.id
                ? axios.put(API, registro)
                : axios.post(API, registro);

            await request;

            setSuccess('Operação realizada com sucesso.');

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function alterarsenha(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            await axios.post(`${API}/alterarsenha`, registro);

            setSuccess('Operação realizada com sucesso.');

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluir(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            await axios.delete(API, {
                params: {
                    id: registro.id
                }
            });

            setSuccess('Operação realizada com sucesso.');

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}